import GraphQLClient from 'services/apollo/GraphQLClient';
import VendorQuery from 'services/graphQL/query/VendorQuery';
import VendorMutation from 'services/graphQL/mutate/VendorMutation';

export default class VendorService {
    constructor() {
        this.graphqlClient = new GraphQLClient();
    }

    /**
     * Get a list of products with filter
     * @param {Object} filter
     * @returns {Promise<any|void>}
     */
    async getSettingList(filter, sort, paginate) {
        const input = {
            paginate, filter, sort,
        };

        return this.graphqlClient
            .query(VendorQuery.GET_SETTINGS_VENDOR_LIST, input)
            .then((response) => {
                const { data, graphQLErrors } = response;
                if (graphQLErrors) {
                    return { graphQLErrors };
                }

                const { getVendorSettingsList } = data;

                return {
                    data: { vendors: getVendorSettingsList.data, totalCount: getVendorSettingsList.totalCount },
                };
            });
    }

    /**
     * Get vendor detail
     * @param {Object} filter
     * @returns {Promise<any|void>}
     */
    async getVendorDetail(input = {}) {
        return this.graphqlClient
            .query(VendorQuery.VENDOR_DETAIL, input)
            .then((response) => {
                const { data, graphQLErrors } = response;
                if (graphQLErrors) {
                    return { graphQLErrors };
                }

                const { getVendorDetail } = data;
                return {
                    data: { vendor: getVendorDetail },
                };
            });
    }

    /**
     * @param {Object} input
    */
    async createVendor(input) {
        return this.graphqlClient
            .mutate(VendorMutation.CREATE_VENDOR, input);
    }

    /**
    * @param {Object} input
    */
    async updateVendor(input) {
        return this.graphqlClient
            .mutate(VendorMutation.UPDATE_VENDOR, input);
    }
}
